// extracted by mini-css-extract-plugin
export default {"policyContainer":"PrivacyPolicy_policyContainer__jk10T","regulationContainer":"PrivacyPolicy_regulationContainer__Nx9mA","policyText":"PrivacyPolicy_policyText__BTXqZ"};